import { router } from "expo-router";
import { theme } from "@theme";
import { useState } from "react";
import { useWindowDimensions } from "react-native";
import config from "@utils/config";
import { getViewPort } from "@utils/web/config";

const BAR_MUSIC_PLAYER_HEIGHT = config.UI.barMusicPlayerHeight;

const openPlayer = () => {
  router.navigate({
    pathname: "/(app)/(tabs)/home",
  });
};

const useBarMusicPlayer = () => {
  const [controlsWidth, setControlsWidth] = useState(150);

  const window = useWindowDimensions();
  const itemWidth =
    getViewPort(window).width - theme.spacing.s2 * 2 - controlsWidth;

  const itemHeight = BAR_MUSIC_PLAYER_HEIGHT - theme.spacing.s2;

  return {
    itemHeight,
    itemWidth,
    openPlayer,
    setControlsWidth,
    BAR_MUSIC_PLAYER_HEIGHT,
  };
};

export default useBarMusicPlayer;
